
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';
import moment from 'moment';
import DateRange from '@/components/DateRange.vue';
import convertToBase64 from '@/utils/image';

const { exchanger } = api;

@Component({
  components: { DateRange },
})
export default class virtualCurrencyThreshold extends Vue {
  private loading = false;

  private valid = false;

  private panel = 0;

  private exchangerOption = [];

  private currencyOption = [];

  private thresholdLogs = [];

  private isTodaySetted = false;

  private isSearched = false;

  private uploadFile: any;

  private headers = [
    { text: '日期', value: 'rateDate' },
    { text: '交易門檻', value: 'exchangeRate' },
  ];

  private searchForm = {
    exchangerId: '',
    currencyId: '',
  }

  private thresholdForm = {
    trasctionDate: moment().format('YYYY-MM-DD'),
    dateRate: 0,
  }

  private rules = {
    fileRule: [
      (v: any) => !!v || !!this.uploadFile || '檔案 為必填',
      (v: any) => !v || v.size < 4000000 || '照片大小不可大於 4 MB!',
    ],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private searchReset() {
    this.searchForm.exchangerId = '';
    this.searchForm.currencyId = '';
    this.thresholdFormReset();
  }

  private thresholdFormReset() {
    this.thresholdForm.dateRate = 0;
    this.isTodaySetted = false;
    this.isSearched = false;
  }

  private async querythresholdLogs() {
    const { data } = await exchanger.currencyRecentRate(
      this.searchForm.exchangerId,
      this.searchForm.currencyId,
    );
    this.thresholdLogs = data || [];
  }

  private async searchSubmit() {
    if (!this.searchForm.exchangerId || !this.searchForm.currencyId) {
      await Swal.fire({ icon: 'warning', title: '請選擇交易所及虛擬幣欄位' });
    } else {
      this.thresholdFormReset();
      await this.querythresholdLogs();
      const todayLog = this.thresholdLogs.find((p: any) => p.rateDate === `${this.thresholdForm.trasctionDate}T00:00:00`) as any;
      if (!!todayLog) {
        this.isTodaySetted = true;
        this.thresholdForm.dateRate = todayLog.exchangeRate;
      }
      this.isSearched = true;
    }
  }

  private async setTodayThreshold() {
    if (!this.thresholdForm.dateRate) {
      await Swal.fire({ icon: 'warning', title: '請設定交易門檻或門檻需大於0' });
    } else {
      await Swal.fire(
        {
          title: `確認設定今日交易門檻為${this.thresholdForm.dateRate}嗎 ?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '取消',
        },
      ).then(async (result) => {
        if (result.isConfirmed) {
          const data = {
            exchangerId: this.searchForm.exchangerId,
            currencyId: this.searchForm.currencyId,
            rate: this.thresholdForm.dateRate,
          };
          const { status, message } = await exchanger.setDailyRate(data);
          if (status === 1) {
            this.isTodaySetted = true;
            await Swal.fire({ icon: 'success', title: '設定成功' });
            await this.querythresholdLogs();
          } else {
            await Swal.fire({ icon: 'warning', title: message });
          }
        }
      });
    }
  }

  private async downloadTransactionLogs() {
    const params = {
      exchangerId: this.searchForm.exchangerId,
      currencyId: this.searchForm.currencyId,
      date: this.thresholdForm.trasctionDate,
    };
    const { status, data } = await exchanger.downloadFiltedDailyTranscrion(params);
    if (status === 1) {
      const fileName = `${this.thresholdForm.trasctionDate}_result_${this.searchForm.exchangerId}_${this.searchForm.currencyId}.txt`;
      Util.saveFile(data, fileName);
    }
  }

  private async uploadTransactionLog() {
    if (this.uploadFile) {
      const data = {
        exchangerId: this.searchForm.exchangerId,
        currencyId: this.searchForm.currencyId,
        date: this.thresholdForm.trasctionDate,
        fileBase64: await convertToBase64(this.uploadFile),
      };
      const { status, message } = await exchanger.uploadDailyTranscrionResult(data);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '本日交易結果上傳完成' });
      } else {
        await Swal.fire({ icon: 'warning', title: message });
      }
    } else {
      await Swal.fire({ icon: 'warning', title: '請上傳交易結果檔案' });
    }
  }

  private changeFile(event: any) {
    if (event) {
      this.uploadFile = event;
    }
  }

  private async bindCurrencyOption() {
    const { data } = await exchanger.currencyOption(this.searchForm.exchangerId, 1);
    this.currencyOption = data;
  }

  private async bindExchangeOption() {
    const { data: { data } } = await exchanger.list({ pageSize: 0, pageNo: 1 });
    this.exchangerOption = data;
  }

  private async created() {
    await this.bindExchangeOption();
  }
}
